import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { DropdownItem, DropdownMenu, DropdownToggle, Nav } from "reactstrap";
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from "@coreui/react";
import logo from "../../assets/img/brand/klimator-logo.svg";
import logoMin from "../../assets/img/brand/klimator-logo-min.svg";
import axios from "axios";

//Redux
import { useDispatch, useSelector } from "react-redux";
import * as authActions from "../../redux/actions/authActions";
import * as i18nActions from "../../redux/actions/i18nActions";

// i18n library
import i18n from "../../i18n";
import { translate } from "../../utils/i18n";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";

const DefaultHeader = (props) => {
  const dispatch = useDispatch();
  const history = props.history;

  const { user, isLoggedIn, language } = useSelector((state) => ({
    user: state.authReducer.user,
    isLoggedIn: state.authReducer.isLoggedIn,
    language: state.i18nReducer.language,
  }));

  const handleLoginClick = () => {
    history.push("/login");
  };

  const handleLogoutClick = () => {
    history.push("/login");
    dispatch(authActions.logout());
  };

  const handleAccountClick = () => {
    if (user && user._id) {
      history.push(`/users/${user._id}`);
    }
  };

  const handleLanguageClick = async (lng) => {
    if (lng === language) return;

    dispatch(i18nActions.setLanguage(lng));
    i18n.changeLanguage(lng);

    const utcOffset = new Date().getTimezoneOffset() / -60;

    try {
      await axios.patch(`${API_ENDPOINTS.USER_CONFIG}`, {
        language: lng,
        utcOffset,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      <AppSidebarToggler className="d-lg-none" display="md" mobile />
      <AppNavbarBrand
        full={{ src: logo, width: 140, height: 50, alt: "Logo" }}
        minimized={{ src: logoMin, width: 50, height: 20, alt: "Logo" }}
      />
      <AppSidebarToggler className="d-md-down-none" display="lg" />
      <Nav className="ml-auto mr-3" navbar>
        <AppHeaderDropdown direction="down">
          <DropdownToggle nav>
            <i className="fa fa-globe fa-2x" />
          </DropdownToggle>
          <DropdownMenu right style={{ right: "auto" }}>
            <DropdownItem header tag="div" className="text-center">
              <strong>{translate("language")}</strong>
            </DropdownItem>
            <DropdownItem onClick={() => handleLanguageClick("da")} active={language === "da"}>
              <i className="flag-icon flag-icon-dk" /> Dansk
            </DropdownItem>
            <DropdownItem onClick={() => handleLanguageClick("en")} active={language === "en"}>
              <i className="flag-icon flag-icon-us" /> English
            </DropdownItem>
          </DropdownMenu>
        </AppHeaderDropdown>
        <AppHeaderDropdown direction="down">
          <DropdownToggle nav>
            <span className="mr-1 text-secondary" hidden={!isLoggedIn}>
              <i className="fa fa-user fa-2x mr-2" />
              {user ? user.name : null}
            </span>
          </DropdownToggle>
          <DropdownMenu right style={{ right: "auto" }}>
            <DropdownItem header tag="div" className="text-center">
              <strong>{translate("account")}</strong>
            </DropdownItem>
            <DropdownItem onClick={handleAccountClick} hidden={!isLoggedIn}>
              <i className="fa fa-sliders" /> {translate("account")}
            </DropdownItem>
            <DropdownItem onClick={handleLoginClick} hidden={isLoggedIn}>
              <i className="fa fa-sign-in" /> {translate("login")}
            </DropdownItem>
            <DropdownItem onClick={handleLogoutClick} hidden={!isLoggedIn}>
              <i className="fa fa-sign-out" /> {translate("logout")}
            </DropdownItem>
          </DropdownMenu>
        </AppHeaderDropdown>
      </Nav>
    </React.Fragment>
  );
};

export default withRouter(DefaultHeader);
